import styled from "styled-components";
import { theme } from "../../core/theme";

export const Box = styled.div`
  background-color: ${theme.colors?.background};
  padding: 80px 5%;
`;
